import { groq } from "next-sanity"

import { groqQueryOptions } from "@/graphql/schemas/shared/utils/groqQueryOptions"
import { AppSettings } from "@/settings"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getCustomer } from "../../shared/utils/getCustomer"
import { groqShortProductProjection } from "../sanity/product.projection"

export const queryProducts = {
  async products(parent, args, context, info) {
    let {
      offset,
      limit,
      sort,
      lang = AppSettings.defaultLocale(),
      cdn = true,
      sortWithinLimits,
      categoryId = null,
      customerId = null,
      vendor = null,
    } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.PRODUCTS,
      operation: Operations.READ,
    })

    if (customerId) {
      const customer = await getCustomer({ id: customerId })

      await validateAccessRightsToCustomer({
        user: user,
        customerNumber: customer.customerNumber,
      })
    }

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    sort = sort ?? ""
    offset = offset ?? 0
    limit = limit ?? -1

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    const vendorFilter = vendor ? ` && vendor._ref == "${vendor}"` : ""
    const categoryFilter = categoryId ? ` && "category-${categoryId}" in categories[]._ref` : ""

    const filteredProducts = `*[_type == "product"${draftsFilter}${categoryFilter}${vendorFilter}]`

    let products
    products = await client.fetch(
      groq`{
        "total": count(${filteredProducts}),
        "items": ${filteredProducts} ${pipesAndLimits} {
            ...,
            ${groqShortProductProjection()}
        }
      }`,
    )

    if (products) {
      return {
        ...products,
        offset,
        limit,
        count: products.items.length,
      }
    } else
      return {
        offset,
        limit,
        count: 0,
        total: 0,
        items: [],
      }
  },
}
